export function findOrThrow<T>(
  list: T[],
  predicate: (item: T) => boolean,
  errorMessage = 'Unable to find required item in list.',
): T {
  const item = list.find(predicate);
  if (item == null) throw new Error(errorMessage);
  return item;
}
